import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "juou-card" }

import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import dayjs from 'dayjs';
import { keyBy } from 'lodash';
import { normalizeBizTableColumns } from '@/utils/tableColumns';

// 小程序 appid -> 名称 映射

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const weappMap = ref<Record<string, string>>({});

// 初始化获取小程序列表
const initWeappMap = async() => {
  try {
    const res = await useApi().weappApi.pageWeappweapp({
      conditions: {},
      pageQuery: { page: 0, pageSize: 1000 },
    });
    const weappList = res.data.data?.data || [];
    weappMap.value = keyBy(weappList.map((item: any) => ({
      appid: item.appid,
      name: item.name || item.appid,
    })), 'appid');
  } catch (err) {
    console.error('获取小程序列表失败', err);
  }
};

// 根据 appid 获取小程序名称
const getWeappName = (appid: string) => (weappMap.value[appid] as any)?.name || appid;

initWeappMap();

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([
  {
    name: 'name',
    label: '目标小程序名称',
    type: 'string',
    isCondition: true,
    rule: [{ required: true }],
  },
  {
    name: 'targetAppid',
    label: '目标小程序AppID',
    type: 'string',
    isCondition: true,
    rule: [{ required: true }],
  },
  {
    name: 'targetPath',
    label: '目标路径',
    type: 'string',
    isCondition: true,
  },
  {
    name: 'nfcUrl',
    label: 'NFC URL',
    type: 'string',
    hideCreate: true,
    hideEdit: true,
    render: (scope: any) => {
      const row = scope?.row || {};
      const { nfcUrl } = row;
      if (!nfcUrl || typeof nfcUrl !== 'object') {
        return '-';
      }
      return (
        <div class="url-list">
          {Object.entries(nfcUrl).map(([appid, url]) => (
            <div class="url-item" key={appid}>
              <span class="url-label">{getWeappName(appid)}:</span>
              <span class="url-value">{url as string}</span>
            </div>
          ))}
        </div>
      );
    },
  },
  {
    name: 'qrcodeUrl',
    label: '二维码 URL',
    type: 'string',
    hideCreate: true,
    hideEdit: true,
    render: (scope: any) => {
      const row = scope?.row || {};
      const { qrcodeUrl } = row;
      if (!qrcodeUrl || typeof qrcodeUrl !== 'object') {
        return '-';
      }
      return (
        <div class="qrcode-list">
          {Object.entries(qrcodeUrl).map(([appid, url]) => (
            <div class="qrcode-item" key={appid}>
              <span class="qrcode-label">{getWeappName(appid)}:</span>
              <img class="qrcode-img" src={useApi().baseUrl + url} alt={appid} />
            </div>
          ))}
        </div>
      );
    },
  },
  {
    name: 'createTime',
    label: '创建时间',
    type: 'string',
    width: 180,
    hideCreate: true,
    hideEdit: true,
    render: (scope: any) => (scope?.row?.createTime ? dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') : '-'),
  },
]));

const tableRef = ref<any>();
const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().jumpWeappApi.pageJumpWeappjumpWeapp({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }
        conditions[key] = val;
        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });
    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您正在进行删除(${row.name || row.targetAppid})操作，请谨慎操作`;

const createFun = useBaseAsync(async(data: any) => {
  await useApi().jumpWeappApi.addJumpWeappjumpWeapp({
    jumpWeappAdminVo: data,
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().jumpWeappApi.updateJumpWeappjumpWeapp({
    jumpWeappAdminVo: data,
  });
  ElMessage.success('修改成功');
});

const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().jumpWeappApi.delJumpWeappjumpWeapp(data.id);
  ElMessage.success('删除成功');
});

return (_ctx: any,_cache: any) => {
  const _component_HpsfirProTable = _resolveComponent("HpsfirProTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HpsfirProTable, {
      ref_key: "tableRef",
      ref: tableRef,
      "export-file-name": "跳转小程序管理",
      title: "跳转小程序管理",
      paginations: { pageSize: 10 },
      columns: columns.value,
      "get-data": _unref(getData),
      "on-delete": _unref(deleteFun),
      "on-edit": _unref(updateFun),
      "on-add": _unref(createFun),
      loading: loading.value,
      "is-dangder-delete": true,
      "format-dangder-delete-info": formatDeleteInfo,
      "row-key": "id"
    }, null, 8, ["columns", "get-data", "on-delete", "on-edit", "on-add", "loading"])
  ]))
}
}

})